import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

/**
 * The four sentences every capture tool needs, the option variant of a
 * capture never names its target (an ask_user thumb is about the question,
 * not about what was framed), which is why `option` carries no subject.
 */
export interface CaptureLabels {
  optionFailed: string;
  optionRunning: string;
  optionDone: string;
  failed: (subject: string | null) => string;
  running: (subject: string | null) => string;
  done: (subject: string | null) => string;
}

export function captureLabel(
  labels: CaptureLabels,
  state: ToolActivityState,
  options: { isOption: boolean; subject: string | null },
): ToolActivity {
  if (options.isOption) {
    if (state.hasFailed) {
      return labelOnly(labels.optionFailed);
    }
    return labelOnly(
      state.isRunning ? labels.optionRunning : labels.optionDone,
    );
  }
  if (state.hasFailed) {
    return labelOnly(labels.failed(options.subject));
  }
  return labelOnly(
    state.isRunning
      ? labels.running(options.subject)
      : labels.done(options.subject),
  );
}
